<template>
  <indiv-nav v-if="isClientHeader" />
  <default-nav v-else />
</template>

<script>
import DefaultNav from './DefaultNav.vue';
import IndivNav from './IndivNav.vue';

export default {
  name: 'hhead',
  components: { DefaultNav, IndivNav },
  computed: {
    isClientHeader() {
      return String(this.$route.query.from) === 'indiv';
    },
  },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/header/index.vue